import { TabContext, TabPanel } from "@mui/lab";
import { InputBase, Tab, Tabs } from "@mui/material";
import Box from "components/common/Box";
import Text from "components/common/Text";
import React from "react";
import { makeStyles } from "@mui/styles";
import Paper from "components/common/Paper";
import IconButton from "components/common/IconButton";
import { GridSearchIcon } from "@mui/x-data-grid";
import Vehicle from "./Vehicle";
import Connector from "./Connector";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import Modal from "components/common/Modal";
import { Backdrop, Fade } from "@mui/material";
import Button from "components/common/Button";
import Grid from "components/common/Grid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
const Request = ({
  value,
  getVarientDropdownData,
  getVarientDropdown,
  modelDropdownData,
  handleTabChange,
  vehicels,
  vehicletoggleDrawerRequest,
  handleRejectRequestVehicle,
  handleApproveRequestVehicle,
  vehicledrawerOpen,
  response,
  responseManufacturer,
  handleCloseModal,
  rejectRequestOpen,
  handleRejectModalOpen,
  handleRejectModalClose,
  handleOnChange,
  handleUpdateRequestVehicle,
  handleFiltertoggleDrawer,
  searchhandleChange,
  totalCount,
  limit,
  page,
  onPageChange,
  isLoading,
  onChange,
  getModalDropdown,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  formData,
  handleVariantInputFieldOpen,
  handleModelInputFieldOpen,
  handleManufacturerInputFieldOpen,
  variantInputFieldOpen,
  modelInputFieldOpen,
  manufacturerInputFieldOpen,
  handleReset
}) => {
  
  const classes = useStyles();
  const downloadAsExcel = () => {
    const conector = vehicels.map((d) => ({
      CustomerName: d?.customer_name,
      MobileNumber: d?.mobile,
      EVType: d?.type_request,
      RegistrationNumber: d?.vehicle_registration_no,
      ManufacturerName: d?.manufacturer,
      ModelName: d?.model,
      VariantName: d?.variant,
      Year: d?.year,
      Usage: d?.usage,
      iam: d?.i_am,
    }));
    const worksheet = XLSX.utils.json_to_sheet(conector);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "connector Data");
    XLSX.writeFile(workbook, "RequestData.xlsx");
  };
 
  return (

    <>
      <Grid container>
        <Grid item xs={12} lg={12}>
          <Paper sx={{ p: 2, mt: 3, marginLeft: "5px", width: "74.5vw" }}>
            <Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box style={{ display: "flex" }}>
                  <Text
                    className={classes.requestheading}
                    variant="h5"
                    color="#707070"
                  >
                    Requests
                  </Text>

                  {totalCount > 0 ? (
                    <Text className={classes.numberCount}>{totalCount}</Text>
                  ) : (
                    ""
                  )}
                </Box>
                <span
                  onClick={() => downloadAsExcel()}
                  className={classes.exportfile}
                >
                  <FileDownloadIcon
                    sx={{ fontSize: "20px", mt: "3px" }}
                    className={classes.fileDownload_icon}
                  />
                  Export Report
                </span>
              </Box>
              <Box>
                <Box sx={{ maxWidth: 200, minWidth: 200 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "14px" }}
                      className={classes.datePickerInput}
                      id="daterange-label"
                    >
                      Date Range
                    </InputLabel>
                    <OutlinedInput
                      sx={{ height: "37px",fontSize:'11px' }}
                      label="Date Range"
                      className={classes.table_date}
                      id="outlined-adornment-amount"
                      value={
                        fromat_date_from && fromat_date_to
                          ? `${fromat_date_from} - ${fromat_date_to}`
                          : ""
                      }
                      onClick={handleDatePickerOpen}
                      endAdornment={
                        <InputAdornment position="end" sx={{cursor:'pointer'}}>
                          <EventIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <div></div>
                </Box>
                <Dialog
                  open={datePickerOpen !== undefined ? datePickerOpen : false}
                  onClose={handleDatePickerClose}
                  title="Select a date range"
                  children={
                    <DatePickerModal
                      onClose={handleDatePickerClose}
                      onDatePickerSub={onDatePickerSub}
                      from_date={from_date}
                      to_date={to_date}
                      handleChange={onChange}
                      handleReset={handleReset}
                    />
                  }
                />
              </Box>
              <Box className={classes.searchBox}>
                <Paper className={classes.paper_searchBox}>
                  <IconButton
                    type="submit"
                    sx={{ p: "5px" }}
                    aria-label="search"
                  >
                    <GridSearchIcon />
                  </IconButton>
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    onChange={(e) => searchhandleChange(e.target.value)}
                    inputProps={{ "aria-label": "search" }}
                  />
                </Paper>

                <Box>
                  <FilterListOutlinedIcon
                    onClick={handleFiltertoggleDrawer}
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                  />
                </Box>
              </Box>
            </Box>

            <TabContext sx={{ width: "90%" }} value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}
              >
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Vehicles"
                    sx={{ textTransform: "none" }}
                    value="1"
                  />
                  {totalCount > 0 ? (
                    <span className={classes.evhicle_numberCount}>
                      {totalCount}
                    </span>
                  ) : (
                    ""
                  )}
                  {/* <Tab
                    label="Connectors"
                    sx={{ textTransform: "none" }}
                    value="2"
                  /> */}
                </Tabs>
              </Box>
              <TabPanel value="1">
                <Vehicle
                getVarientDropdownData={getVarientDropdownData}
                getVarientDropdown={getVarientDropdown}
                modelDropdownData={modelDropdownData}
                getModalDropdown={getModalDropdown}
                  handleSubmit={handleRejectModalOpen}
                  toggleDrawer={vehicletoggleDrawerRequest}
                  response={response}
                  vehicledrawerOpen={vehicledrawerOpen}
                  data={vehicels}
                  responseManufacturer={responseManufacturer}
                  handleApproveRequestVehicle={handleApproveRequestVehicle}
                  handleCloseModal={handleCloseModal}
                  handleOnChange={handleOnChange}
                  handleUpdateRequestVehicle={handleUpdateRequestVehicle}
                  page={page}
                  limit={limit}
                  totalCount={totalCount}
                  onPageChange={onPageChange}
                  isLoading={isLoading}
                  formData={formData}
                  handleVariantInputFieldOpen={handleVariantInputFieldOpen}
                  handleModelInputFieldOpen={handleModelInputFieldOpen}
                  handleManufacturerInputFieldOpen={handleManufacturerInputFieldOpen}
                  variantInputFieldOpen={variantInputFieldOpen}
                  modelInputFieldOpen={modelInputFieldOpen}
                  manufacturerInputFieldOpen={manufacturerInputFieldOpen}
                />
              </TabPanel>
              <TabPanel value="2">
                <Connector
                  data={[]}
                  toggleDrawer={vehicletoggleDrawerRequest}
                  vehicledrawerOpen={vehicledrawerOpen}
                  response={response}
                />
              </TabPanel>
            </TabContext>
          </Paper>
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={rejectRequestOpen}
        onClose={handleRejectModalClose}
        closeAfterTransition
        size="xs"
        BackdropComponent={Backdrop}
      >
        <Fade in={rejectRequestOpen}>
          <div className={classes.modle_container}>
            <div className={classes.modle}>
              <Text className={classes.reject_text}>
                Reject Request Confirmation
              </Text>
              <span>Are you sure you want to reject this request ?</span>
            </div>
            <Box className={classes.modlecontainer}>
              <Button
                className={classes.no_button}
                variant="outlined"
                color="primary"
                onClick={handleRejectModalClose}
              >
                No
              </Button>
              <Button
                className={classes.yes_button}
                variant="contained"
                color="primary"
                onClick={handleRejectRequestVehicle}
              >
                Yes
              </Button>
            </Box>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  exportfile: {
    height: "25px",
    background: "#19AA69",
    cursor: "pointer",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },

  modlecontainer: {
    display: "flex",
    justifyContent: "space-around",
  },
  modle: {
    textAlign: "center",
    marginBottom: "20px",
  },

  requestheading: {
    fontSize: "22px",
    marginBottom: "40px",
  },
  reject_text: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  yes_button: {
    padding: "5px 50px",
    fontSize: "14px",
  },
  no_button: {
    padding: "5px 50px",
    fontSize: "14px",
  },
  table: {
    "@media (max-width:768px)": {
      marginTop: "99%",
    },
  },
  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    display: "flex",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginTop: "25px",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  numberCount: {
    fontSize: "15px",
    padding: "5px",
    borderRadius: "50%",
    height: "25px",
    marginLeft: "5px",
    background: "lightgray",
    marginBottom: "20px",
    width: '25px',
    textAlign: 'center',
  },
  evhicle_numberCount: {
    fontSize: "15px",
    padding: "5px",
    borderRadius: "50%",
    height: "25px",
    width: '25px',
    textAlign: 'center',
    marginLeft: "5px",
    marginTop: "10px",
    background: "lightgray",
  },
  paper_searchBox: {
    p: "2.5px 0",
    display: "flex",
    alignItems: "center",
    width: "200px",
    height: "32px",
  },
}));

export default Request;
